import { render, staticRenderFns } from "./EventContestDetail.vue?vue&type=template&id=21ef1c24&scoped=true"
import script from "./EventContestDetail.vue?vue&type=script&lang=ts"
export * from "./EventContestDetail.vue?vue&type=script&lang=ts"
import style0 from "./EventContestDetail.vue?vue&type=style&index=0&id=21ef1c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef1c24",
  null
  
)

export default component.exports